export default [
  {
    path: '/',
    redirect: '/forms',
  },
  {
    path: '/forms',
    meta: {
      layout: 'blank',
    },
    component: () => import('@app/pages/FormPage'),
  },
  {
    path: '/complete',
    meta: {
      layout: 'blank',
    },
    component: () => import('@app/pages/Complete'),
  },
]
